function pluralize(time, label) {
	if (time === 1) {
		return time + label
	}
	return time + label + 's'
}

export function timeAgo(time) {
	const between = Date.now() / 1000 - Number(time)
	if (between < 3600) {
		return pluralize(~~(between / 60), ' minute')
	} else if (between < 86400) {
		return pluralize(~~(between / 3600), ' hour')
	} else {
		return pluralize(~~(between / 86400), ' day')
	}
}



export function parseTime(time, format) {
	if (arguments.length === 0) {
		return null
	}

	if ((time + '').length === 10) {
		time = +time * 1000
	}

	format = format || '{y}-{m}-{d} {h}:{i}:{s}'
	let date
	if (typeof time === 'object') {
		date = time
	} else {
		date = new Date(parseInt(time))
	}
	const formatObj = {
		y: date.getFullYear(),
		m: date.getMonth() + 1,
		d: date.getDate(),
		h: date.getHours(),
		i: date.getMinutes(),
		s: date.getSeconds(),
		a: date.getDay()
	}
	const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
		let value = formatObj[key]
		if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
		if (result.length > 0 && value < 10) {
			value = '0' + value
		}
		return value || 0
	})
	return time_str
}

export function parseDate(time,format) {
	format = format || '{y}-{m}-{d}'
	return parseTime(time,format)
}
export function parseTimeAgo(time) {
	const between = Date.now() / 1000 - Number(time)
	if (between < 60) {
		return '刚刚';
	}
	else if (between < 3600) {
		return ~~(between / 60)+'分钟前';
	}
	else if (between < 86400) {
		return ~~(between / 3600)+'小时前';
	}
	else {
		return ~~(between / 86400) +'天前';
	}
}

export function parseMixTime(time, option) {
	const between = Date.now() / 1000 - Number(time)
	if(between<86400*30){
		return parseTimeAgo(time);
	}

	return parseTime(time,option)

}
export function parseMixDate(time, option) {
	const between = Date.now() / 1000 - Number(time)
	if(between<86400*30){
		return parseTimeAgo(time);
	}

	return parseDate(time,option)

}



/* 数字 格式化*/
export function nFormatter(num, digits) {
	const si = [
		{ value: 1E18, symbol: 'E' },
		{ value: 1E15, symbol: 'P' },
		{ value: 1E12, symbol: 'T' },
		{ value: 1E9, symbol: 'G' },
		{ value: 1E6, symbol: 'M' },
		{ value: 1E3, symbol: 'k' }
	]
	for (let i = 0; i < si.length; i++) {
		if (num >= si[i].value) {
			return (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
		}
	}
	return num.toString()
}

export function html2Text(val) {
	const div = document.createElement('div')
	div.innerHTML = val
	return div.textContent || div.innerText
}

export function toThousandslsFilter(num) {
	return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}



// WEBPACK FOOTER //
// ./src/filters/index.js